import React from 'react';

import { LANDING_PAGE_SECTIONS_NAMES } from 'Utilities/analytics';
import { useFeatureFlags } from 'Utilities/hooks';
import { CAR_PRIZE_DRAW_ROUTE } from 'Utilities/routing';

import { ComponentContent, CONTENT_SIZES } from 'Layout';

import { useMetaTags } from 'Hooks/misc/useMetaTags';

import { RoundedSection } from '../../../common/RoundedSection/RoundedSection';
import FastlaneHero from '../../../fastlane/home/Hero/Hero';
import { ExpandableContentWrapper } from '../../Components/ExpandableContentWrapper/ExpandableContentWrapper';

import { EligibilityAndEntryCriteria } from './EligibilityAndEntryCriteria/EligibilityAndEntryCriteria';
import { HowToEnter } from './HowToEnter/HowToEnter';
import { PrizeSection } from './PrizeSection/PrizeSection';
import { QuotesSection } from './QuotesSection/QuotesSection';
import { carPrizeDrawSectionLoadEvent } from './CarPrizeDraw.helpers';
import Texts from './CarPrizeDraw.texts.json';

import styles from './CarPrizeDraw.module.scss';

const CarPrizeDrawContent: React.FC = () => {
  useMetaTags({
    description: Texts.meta.description,
    title: Texts.meta.title,
  }, CAR_PRIZE_DRAW_ROUTE);

  const { showCarPrizeDraw } = useFeatureFlags();
  const heroTexts = showCarPrizeDraw ? Texts.open.hero : Texts.closed.hero;

  return (
    <div className={styles.component}>
      <div className={styles.heroSection}>
        <FastlaneHero
          isHideBreadcrumb={false}
          subTitle={heroTexts.description}
          title={heroTexts.title}
        />
        <RoundedSection withBottomLedge withTopLedge theme="off-white">
          <PrizeSection />
        </RoundedSection>
      </div>
      {showCarPrizeDraw
      && <RoundedSection withBottomLedge withTopLedge>
        <ComponentContent maxWidth={CONTENT_SIZES.container}>
          <HowToEnter/>
        </ComponentContent>
      </RoundedSection>}
      <QuotesSection/>
      {showCarPrizeDraw && <>
        <EligibilityAndEntryCriteria/>
        <ExpandableContentWrapper
          faq={Texts.faq.items}
          faqTitle={Texts.faq.title}
          onLoad={() => carPrizeDrawSectionLoadEvent(LANDING_PAGE_SECTIONS_NAMES.FAQ)}
        />
      </>}
    </div>
  );
};

export const CarPrizeDraw: React.FC = () => <CarPrizeDrawContent />;

export default CarPrizeDraw;
